import { FieldsEnum } from 'src/enums/FieldsEnum';
import moment from 'moment';

export interface EventLogsType {
  activeKey: string;
  defaultKey: string;
}

export interface LogsData {
  key: number;
  user: string;
  event: string;
  action: string;
  field: string;
  details: string;
  timestamp: string;
  originalTimestamp?: moment.Moment;
}

export const actionColors = {
  CREATE: 'green',
  UPDATE: '#1677FF',
  DELETE: '#e60000',
  Unknown: 'gray',
};

export const actionColorsInForm = {
  CREATE: '#009900',
  UPDATE: '#146be6',
  DELETE: '#e60000',
  Unknown: 'gray',
};

export const fieldTypeToLocationMap = {
  FMM: [
    FieldsEnum.OBJECTIVE,
    FieldsEnum.INCIDENT_FOLDER,
    FieldsEnum.INCIDENT,
    FieldsEnum.INJECTION,
    FieldsEnum.ACTION,
    FieldsEnum.OUTCOME,
    FieldsEnum.OBSERVATION_TASK,
  ],
  RLSM: [FieldsEnum.CONFIGURATION_CHANGE_REQUEST, FieldsEnum.TROUBLE_TICKET, FieldsEnum.TECHNICAL_SUPPORT_REQUEST],
  PPM: [
    FieldsEnum.PROJECT_INPUT,
    FieldsEnum.KANBAN,
    FieldsEnum.DELIVERABLE,
    FieldsEnum.TEST,
    FieldsEnum.TASK,
    FieldsEnum.WORK_PACKAGE,
  ],
  FLOW: [FieldsEnum.STATE, FieldsEnum.TRANSACTION],
  LILL: [FieldsEnum.LILL],
  SSM: [FieldsEnum.ACTORBOOK, FieldsEnum.ROAD_TO_CURRENT_SETTINGS],
  ADMINISTRATION: [FieldsEnum.SETTING],
  ODC2M: [
    FieldsEnum.PHASE,
    FieldsEnum.LINE_OF_EFFORT,
    FieldsEnum.PLAN_ORDER_REPORT_PROCESS,
    FieldsEnum.DECISIVE_CONDITIONS,
    FieldsEnum.OD_TASK,
    FieldsEnum.EFFECT,
  ],
};

export const LogableFieldsPermissionMap: { [key: string]: number[] } = {
  CONFIGURATION_CHANGE_REQUEST: [15001],
  TROUBLE_TICKET: [16001],
  TECHNICAL_SUPPORT_REQUEST: [22001],
  INCIDENT_FOLDER: [5001],
  INCIDENT: [6001],
  INJECTION: [7001],
  ACTION: [8001],
  OUTCOME: [9001],
  OBSERVATION_TASK: [10001],
  LILL: [21001],
  TASK: [29001],
  WORK_PACKAGE: [28001],
  PROJECT_INPUT: [30001],
  KANBAN: [31001],
  DELIVERABLE: [32001],
  TEST: [33001],
  OBJECTIVE: [11001],
  STATE: [35001, 37001, 39001, 52001],
  TRANSACTION: [36001, 38001, 40001, 53001],
  PHASE: [43001],
  LINE_OF_EFFORTS_OPERATIONS: [44001],
  PLAN_ORDER_REPORT_DP: [45001],
  DECISIVE_CONDITIONS: [46001],
  TASKS_ACTIONS: [47001],
  EFFECTS: [48001],
};
